import { IContactAddress } from '@trii/types/dist/Contacts';
import { styled } from '@mui/system';
import { Box, IconButton, Tooltip } from '@mui/material';
import LocalPhoneIcon from '@mui/icons-material/LocalPhone';
import { useMemo } from 'react';
import { Star, StarBorder } from '@mui/icons-material';
import { formatPhoneForDisplay } from './utils/phone';

type Props = {
  item: IContactAddress;
};

const StyledIconButton = styled(IconButton)(({ theme }) => ({
  padding: theme.spacing(0.5),
  marginTop: '-5px',
}));

const StyledLocalPhoneIcon = styled(LocalPhoneIcon)(({ theme }) => ({
  height: 16,
  width: 16,
  color: theme.palette.secondary.main
}));

const StyledBox = styled(Box)(({ theme }) => ({
  display: 'flex',
  alignItems: 'flex-start',
  justifyContent: 'space-between',
  padding: theme.spacing(1),
  backgroundColor: theme.palette.background.dropdownMenu,
  borderRadius: theme.shape.borderRadius,
  color: theme.palette.text.primary,
  width: '50%',
  paddingBottom: '3px',
  minHeight: '50px',
  position: 'relative',
}));

const LeftSection = styled(Box)(({ theme }) => ({
  display: 'flex',
  alignItems: 'flex-start',
  gap: theme.spacing(1),
  maxWidth: '80%',
}));
const RightSection = styled(Box)(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  gap: theme.spacing(1),
}));
const ContactDetails = styled(Box)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'flex-start',
  gap: theme.spacing(0.5),
  overflow: 'hidden',
  flexFlow: 'nowrap',
  flexWrap: 'wrap',
  marginTop: '-5px',
}));

const EllipsisText = styled(Box)(({}) => ({
  fontSize: 14,
  fontWeight: 500,
  whiteSpace: 'nowrap',
  overflow: 'hidden',
  textOverflow: 'ellipsis',
}));
const NoteText = styled(EllipsisText)(({ theme }) => ({
  fontSize: 12,
  color: theme.palette.text.secondary,
  position: 'absolute',
  bottom: 0,
  maxWidth: '70%',
}));
const PhoneText = styled(EllipsisText)(({}) => ({
  fontSize: 14,
  fontWeight: 500,
}));

const ContactMethodPhoneItem = ({ item }: Props) => {
  const handleCallContact = () => {
    const contactPhone = item.address;
    if (!contactPhone) return;

    const event = new CustomEvent('call-contact-header', {
      detail: { phoneAddress: contactPhone },
    });
    window.dispatchEvent(event);
  };

  const formattedPhone = useMemo(
    () => formatPhoneForDisplay(item.address || ''),
    [item.address]
  );

  return (
    <>
      <StyledBox>
        <LeftSection>
          <StyledIconButton
            onClick={handleCallContact}
            color="primary"
            size="small"
          >
            <StyledLocalPhoneIcon />
          </StyledIconButton>
          <ContactDetails>
            <Tooltip title={formattedPhone || ''} arrow>
              <PhoneText>{formattedPhone}</PhoneText>
            </Tooltip>
            <Tooltip title={item.note || ''} arrow>
              <NoteText>{item.note}</NoteText>
            </Tooltip>
          </ContactDetails>
        </LeftSection>
        <RightSection>
          <Box
            sx={{
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'flex-end',
            }}
          >
            <IconButton
              size="small"
              sx={{ marginTop: '-5px', padding: 0 }}
            >
              {item.isFavorite ? (
                <Star
                  sx={{
                    color: '#fcac34',
                  }}
                />
              ) : (
                <StarBorder
                  sx={{
                    color: '#fcac34',
                  }}
                />
              )}
            </IconButton>
          </Box>
        </RightSection>
      </StyledBox>
    </>
  );
};

export default ContactMethodPhoneItem;
